var _style, _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E0E0E0;}\n\t.st1{fill:#263238;}\n\t.st2{fill:#37474F;}\n\t.st3{fill:#455A64;}\n\t.st4{fill:none;stroke:#FAFAFA;stroke-width:0.7403;stroke-miterlimit:10;}\n\t.st5{opacity:0.2;enable-background:new    ;}\n\t.st6{fill:none;stroke:#FAFAFA;stroke-width:0.7403;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st7{opacity:0.1;enable-background:new    ;}\n\t.st8{fill:#1C7280;}\n\t.st9{opacity:0.5;enable-background:new    ;}\n\t.st10{opacity:0.23;enable-background:new    ;}\n\t.st11{opacity:0.38;enable-background:new    ;}\n\t.st12{opacity:0.4;enable-background:new    ;}\n\t.st13{opacity:0.3;enable-background:new    ;}\n\t.st14{opacity:0.45;enable-background:new    ;}\n\t.st15{opacity:0.7;}\n\t.st16{fill:#FFFFFF;}\n\t.st17{opacity:0.7;fill:#FFFFFF;enable-background:new    ;}\n\t.st18{opacity:0.65;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow_28_",
    className: "st0",
    points: "328.8,411.5 222.5,350.1 344.1,279.9 450.4,341.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shadow_27_",
    className: "st0",
    points: "39.3,392.5 176.5,471.7 291.5,405.3 154.3,326.1  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Bookshelf_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bookshelf_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.7,93l-78.5-45.3c-1.7-1-3.2-1.1-4.3-0.4c-1,0.6-4.6,2.7-5.6,3.3c-1.1,0.6-1.8,2-1.8,3.9v214.9 c0,3.9,2.7,8.5,6,10.4l78.5,45.3c1.7,1,3.2,1.1,4.3,0.4c1-0.6,4.7-2.7,5.7-3.3c1.1-0.6,1.8-2,1.8-3.9V103.5 C447.8,99.6,445.1,94.9,441.7,93z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M368.5,273.1l-5.7,3.3v17.9c0,1,0.7,2.1,1.5,2.6l2.6,1.5c0.8,0.5,2.2,0.5,3,0l2.6-1.5 c0.8-0.5,1.8-1.6,2.1-2.5l5.1-14.7L368.5,273.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M362.8,294.2c0,1,0.7,2.1,1.5,2.6l2.6,1.5c0.8,0.5,1.8,0.1,2.1-0.8l5.1-14.7l-11.3-6.5V294.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M425.1,305.7l-5.7,3.3v17.9c0,1,0.7,2.1,1.5,2.6l2.6,1.5c0.8,0.5,2.2,0.5,3,0l2.6-1.5 c0.8-0.5,1.8-1.6,2.1-2.5l5.1-14.7L425.1,305.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M419.5,326.8c0,1,0.7,2.1,1.5,2.6l2.6,1.5c0.8,0.5,1.8,0.1,2.1-0.8l5.1-14.7l-11.3-6.5V326.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M358,51.1l78.5,45.3c3.3,1.9,6,6.6,6,10.4v214.9c0,1.9-0.7,3.3-1.8,3.9c-1.1,0.6-2.6,0.5-4.3-0.4L358,279.9 c-3.3-1.9-6-6.6-6-10.4V54.6c0-1.9,0.7-3.3,1.8-3.9C354.8,50.1,356.3,50.2,358,51.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "243.9,344.9 328.9,394 447.8,325.3 442.1,322 357.2,273 243.9,338.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "328.9,394 328.9,387.4 447.8,318.8 447.8,325.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329,384.2c15.9-24,15-66.5,13.6-73.7c0,0,6.7,44.9,15,57.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M345.4,326.8c2.7,13.1,33.7,22.3,33.7,22.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M342.4,339.8c0.9-2.1,5.2-2.4,6,1c0,0,0.5-6.4,4.1-4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M341.1,349.1c1.6-3.4,7.5-5.3,10.1,2.8c0,0,0.4-14.5,10-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M338.4,362c3.4-6.5,12.6-9.1,15-3.1c0.1-7.4,8.5-16.6,18.8-12.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.7,377.5c3.9-7.2,13.6-20.1,22.1-14.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "436.4,253.4 436.4,259.9 328.9,322 243.9,273 243.9,266.5 351.5,204.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "436.4,253.4 328.9,315.5 243.9,266.5 351.5,204.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "436.4,181.5 436.4,188 328.9,250.1 243.9,201.1 243.9,194.5 351.5,132.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "436.4,181.5 328.9,243.6 243.9,194.5 351.5,132.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Side_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.5,158.3L250,113c-1.7-1-3.2-1.1-4.3-0.4c-1,0.6-4.6,2.7-5.6,3.3c-1.1,0.6-1.8,2-1.8,3.9v214.9 c0,3.9,2.7,8.5,6,10.4l78.5,45.3c1.7,1,3.2,1.1,4.3,0.4c1-0.6,4.7-2.7,5.7-3.3c1.1-0.6,1.8-2,1.8-3.9V168.8 C334.5,164.9,331.8,160.2,328.5,158.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "328.9,191.3 334.5,188 334.5,168.4 328.8,171.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "442.1,125.9 447.8,122.7 447.8,103 442.1,106.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.3,338.4l-5.7,3.3v17.9c0,1,0.7,2.1,1.5,2.6l2.6,1.5c0.8,0.5,2.2,0.5,3,0l2.6-1.5 c0.8-0.5,1.8-1.6,2.1-2.5l5.1-14.7L255.3,338.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.6,359.5c0,1,0.7,2.1,1.5,2.6l2.6,1.5c0.8,0.5,1.8,0.1,2.1-0.8l5.1-14.7l-11.3-6.5V359.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M311.9,371l-5.7,3.3v17.9c0,1,0.7,2.1,1.5,2.6l2.6,1.5c0.8,0.5,2.2,0.5,3,0l2.6-1.5 c0.8-0.5,1.8-1.6,2.1-2.5l5.1-14.7L311.9,371z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M306.2,392.1c0,1,0.7,2.1,1.5,2.6l2.6,1.5c0.8,0.5,1.8,0.1,2.1-0.8l5.1-14.7l-11.3-6.5V392.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M244.3,116.3l78.5,45.3c3.3,1.9,6,6.6,6,10.4v214.9c0,1.9,0,7,0,7s-4.4-2.6-6-3.5l-78.5-45.3 c-3.3-1.9-6-6.6-6-10.4V119.8c0-1.9,0.7-3.3,1.8-3.9C241.2,115.3,242.7,115.4,244.3,116.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M322.8,161.6l-78.5-45.3c-1.7-1-3.2-1.1-4.3-0.4c-1.1,0.6-1.8,2-1.8,3.9V139l90.6,52.3V172 C328.9,168.2,326.2,163.5,322.8,161.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "368.5,152.1 430.8,116.1 430.8,181.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "419.5,165.1 430.8,116.1 408.1,155.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 430.8,
    y1: 116.1,
    x2: 396.8,
    y2: 148.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M430.8,171.1c0-9.2-10.4-9.7-10.4-9.7c0.6-2.8-0.1-7.2-3.4-10.1c-3.4-2.9-5.7-1.3-6.3-0.1 c0,0,0.7-8.4-6.6-9.2c0,0,4.8-8.9,0-10.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M430.8,157c-0.4-4.7-4-10.7-7.6-7.8c0,0,1-10.2-6.3-8.9c0,0,3.4-9.5-3.8-7.1c0,0,5.2-6.5,1.2-7.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Top_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M461.2,93.2c0-1.3-0.8-2.5-2.5-3.5l-84.2-48.6c-3.3-1.9-8.7-1.9-12.1,0L233,115.9c-1.7,1-2.5,2.2-2.5,3.5 c0,1.2,0,5.4,0,6.5c0,1.3,0.8,2.5,2.5,3.5l84.2,48.6c3.3,1.9,8.7,1.9,12.1,0l129.5-74.8c1.7-1,2.5-2.2,2.5-3.5 C461.2,98.6,461.2,94.4,461.2,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M317.2,171.5L233,122.9c-3.3-1.9-3.3-5,0-7l129.5-74.8c3.3-1.9,8.7-1.9,12.1,0l84.2,48.6c3.3,1.9,3.3,5,0,7 l-129.5,74.8C325.9,173.4,320.5,173.4,317.2,171.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadows_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "442.1,112.8 402.5,161.9 334.5,201.1 334.5,174.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "436.4,188 402.5,233.8 334.5,273 334.5,246.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "436.4,259.9 402.5,305.7 334.5,344.9 334.5,318.8  "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Box_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_820_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_848_",
    className: "st8",
    points: "280.6,402.8 176.4,462.9 59.1,395 163.3,334.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_846_",
    className: "st9",
    points: "280.6,402.8 176.4,462.9 59.1,395 163.3,334.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_845_",
    className: "st8",
    points: "163.3,253.4 163.3,334.9 59.1,395 59.1,313.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_844_",
    className: "st10",
    points: "163.3,253.4 163.3,334.9 59.1,395 59.1,313.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_843_",
    className: "st8",
    points: "176.4,381.4 176.4,462.9 59.1,395 59.1,313.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_842_",
    className: "st11",
    points: "176.4,381.4 176.4,462.9 59.1,395 59.1,313.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_841_",
    className: "st8",
    points: "280.6,321.2 280.6,402.8 163.3,334.9 163.3,253.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_840_",
    className: "st12",
    points: "280.6,321.2 280.6,402.8 163.3,334.9 163.3,253.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_839_",
    className: "st8",
    points: "280.6,402.8 280.6,321.2 176.4,381.4 176.4,462.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_838_",
    className: "st10",
    points: "280.6,402.8 280.6,321.2 176.4,381.4 176.4,462.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_830_",
    className: "st8",
    points: "163.3,253.4 163.4,208.2 280.5,276.2 280.6,321.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_829_",
    className: "st5",
    points: "163.3,253.4 163.4,208.2 280.5,276.2 280.6,321.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_828_",
    className: "st8",
    points: "176.4,381.4 186.2,341.9 289.4,282.3 280.6,321.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_827_",
    className: "st13",
    points: "176.4,381.4 186.2,341.9 289.4,282.3 280.6,321.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_825_",
    className: "st8",
    points: "59.1,313.5 46.7,272.6 150.9,212.4 163.3,253.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_824_",
    className: "st7",
    points: "59.1,313.5 46.7,272.6 150.9,212.4 163.3,253.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_823_",
    className: "st8",
    points: "59.1,313.5 34.6,279.7 151.9,347.5 176.4,381.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_821_",
    className: "st14",
    points: "59.1,313.5 34.6,279.7 151.9,347.5 176.4,381.4  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_809_",
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_815_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_818_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_819_",
    className: "st16",
    d: "M207.1,438.7c-0.4,0-0.6-0.3-0.6-0.6v-14.3c0-0.4,0.3-0.6,0.6-0.6s0.6,0.3,0.6,0.6V438 C207.7,438.4,207.5,438.7,207.1,438.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_816_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_817_",
    className: "st16",
    d: "M205.2,428.6c-0.1,0-0.2,0-0.3-0.1c-0.3-0.1-0.5-0.5-0.3-0.8l2.3-5.3l2.5,2.9 c0.2,0.3,0.2,0.7-0.1,0.9c-0.3,0.2-0.7,0.2-0.9-0.1l-1.2-1.4l-1.5,3.4C205.7,428.5,205.5,428.6,205.2,428.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_810_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_813_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_814_",
    className: "st16",
    d: "M213,435.3c-0.4,0-0.6-0.3-0.6-0.6v-14.3c0-0.4,0.3-0.6,0.6-0.6c0.4,0,0.6,0.3,0.6,0.6 v14.3C213.7,435,213.4,435.3,213,435.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_811_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_812_",
    className: "st16",
    d: "M211.1,425.3c-0.1,0-0.2,0-0.3-0.1c-0.3-0.1-0.5-0.5-0.3-0.8l2.3-5.3l2.5,2.9 c0.2,0.3,0.2,0.7-0.1,0.9c-0.3,0.2-0.7,0.2-0.9-0.1l-1.2-1.4l-1.5,3.4C211.6,425.1,211.4,425.3,211.1,425.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_802_",
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_807_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_808_",
    className: "st16",
    d: "M190,448.4c-0.3,0-0.5-0.1-0.7-0.2c-0.5-0.3-0.8-0.8-0.8-1.5v-1.8c0-0.4,0.3-0.6,0.6-0.6 s0.6,0.3,0.6,0.6v1.8c0,0.3,0.1,0.4,0.1,0.4c0,0,0.2,0,0.4-0.1c0.6-0.3,1.2-1.6,1.2-2.9v-7.3c0-0.4,0.3-0.6,0.6-0.6 s0.6,0.3,0.6,0.6v7.3c0,1.7-0.8,3.4-1.8,4C190.7,448.3,190.4,448.4,190,448.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_803_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_804_",
    className: "st16",
    d: "M183.3,442.5v-1.1c0-5.2,3.7-11.6,8.2-14.2c2.3-1.3,4.5-1.5,6.2-0.6c1.7,1,2.6,3,2.6,5.6 v0.4L183.3,442.5z M195.3,427.3c-1,0-2,0.3-3.2,1c-3.8,2.2-7,7.4-7.5,11.9l14.4-8.3c-0.1-2-0.8-3.5-2-4.2 C196.5,427.4,196,427.3,195.3,427.3z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "34.6,279.7 151.9,347.5 176.4,381.4 150.6,348.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "280.6,321.2 176.4,381.4 176.4,462.9 178.4,383  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Moth_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Moth_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.7,288.6c10.7-1.6,20.6-8.4,26.8-17.2c2.9-4.1,5.1-8.6,6.4-13.5c1.1-4.4,1.8-9.4,0.6-14 c-1.9-7.7-9.1-12.3-16.7-13.3c-3.8-0.5-7.8-0.1-11.4,1.1c-3.9,1.3-7.1,3.8-9.5,7.1c-1.2,1.7-2.5,3.9-2.6,6.1 c-0.1,1.9,1.3,3.3,3.2,3.6c2.2,0.4,4.6-0.6,6.5-1.6c2.3-1.3,4.3-3,6-5.1c3.4-4.3,6.3-9.5,7.8-14.8c1.3-4.6,1-9.6,0-14.2 c-1-4.7-3-9.5-6.4-13c-3.6-3.6-8.8-5.4-13.7-6.1c-5-0.7-10.4-0.2-15.2,1.5c-2.1,0.7-4.2,1.7-5.8,3.2c-1.2,1.1-2.6,3-2.1,4.8 c0.6,2,3.2,2.7,5,2.4c2.7-0.3,5.2-2,7.1-3.8c2.1-2,3.9-4.5,5.3-7c1-1.9,1.6-4,1.6-6.1c-0.2-9-10.1-14.8-17.8-16.4 c-2.1-0.4-4.2-0.6-6.4-0.4c-0.7,0.1-0.3,1.2,0.3,1.1c4.1-0.3,8.3,0.9,11.9,2.7c3.5,1.8,6.8,4.3,8.8,7.8c1.9,3.5,1.7,7.5-0.3,10.9 c-1.4,2.3-3.1,4.7-5.1,6.5c-1.7,1.5-4.2,3.3-6.6,3.1c-0.7-0.1-1.6-0.4-1.9-1.2c-0.3-0.9,0.4-2,0.8-2.6c1.1-1.4,2.9-2.3,4.6-3 c4.1-1.8,8.9-2.4,13.4-2.2c4.6,0.2,9.4,1.4,13.2,4.3c3.5,2.6,5.6,6.7,6.9,10.9c1.3,4.3,1.8,9,1.2,13.4c-0.6,4.5-2.8,8.9-5.1,12.7 c-2.6,4.3-5.9,8.4-10.8,10.2c-1.2,0.4-3.8,1.1-4.2-0.7c-0.5-1.8,0.9-3.9,1.8-5.3c2-3.1,4.8-5.5,8.2-6.9c3.2-1.3,6.8-1.8,10.3-1.6 c6.7,0.5,13.4,4,15.7,10.6c1.4,3.9,1.1,8.2,0.4,12.1c-0.8,4.4-2.4,8.6-4.7,12.5c-4.8,8.3-12.3,14.5-21,18.3 c-2.1,0.9-4.3,1.7-6.4,2.4C127.4,288.1,127.5,288.7,127.7,288.6L127.7,288.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M82.9,166c-5.7-0.4-13.4,4-10.7,7.3c2.8,3.2,10.1-2,10.1-2s-0.7,6.6,1.7,7.3c2.4,0.7,5.6-5.5,3.2-9.5 c0,0,3.6,1.6,7-0.9c3.4-2.5-0.2-4.9-5-4.5c0,0,3.4-11.3-3.5-9.1C82.3,155.7,81.1,159.7,82.9,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M82.9,166c-5.7-0.4-13.4,4-10.7,7.3c2.8,3.2,10.1-2,10.1-2s-0.7,6.6,1.7,7.3c2.4,0.7,5.6-5.5,3.2-9.5 c0,0,3.6,1.6,7-0.9c3.4-2.5-0.2-4.9-5-4.5c0,0,3.4-11.3-3.5-9.1C82.3,155.7,81.1,159.7,82.9,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.1,168.4c-0.3-0.3-0.6-0.6-1-0.9c-0.5-0.4-1-0.7-1.5-1.1c-0.5-0.4-1-0.7-1.5-0.9 c-0.3-0.2-0.6-0.3-0.9-0.5c-0.5-0.2-0.9-0.3-1.4-0.2c-0.5,0.1-0.9,0.6-0.6,1.1c0.4,0.6,1,0.7,1.5,0.9c0.3,0.1,0.5,0.3,0.8,0.4 c0.5,0.3,1,0.7,1.5,1c0.5,0.4,1,0.7,1.5,1c0.7,0.6,1.5,1.1,2.4,1.5c0.1,0,0.2,0,0.3,0C89.6,170.2,88.5,168.8,88.1,168.4z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.b6939a014a45e75373d2e05ebf255f8c.svg";
export { ForwardRef as ReactComponent };